<script>
	// Stores
	import IncomingBetStore from '@/Stores/IncomingBetStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Constants
	import { BetType } from '@/Constants/Bet.js';
	// Services
	import { getDivisor, multiOdds, NumberTransform } from '@/Services/Helpers.js';
	import { CurrencyFormat } from '@/Services/Helpers';
	import { getBetOddsForDisplay, getLiabilityForBet } from '@/Common/Bet.js';

	export let open = false;
	export let bet;
	export let amount = 0;

	let element;
	let sending = false;

	$: open && element && element.focus();
	$: eachWay = bet && bet.bet_type.id == BetType.EachWay;
	$: fixedPrice = bet && calcOdds();
	$: winAmount = bet && fixedPrice && parseFloat(getLiabilityForBet(bet).toString()) * getDivisor();
	$: stake = amount && transformedAmount && fixedPrice && calcStake();
	$: transformedAmount = amount && NumberTransform(amount, false);
	$: error =
		amount && winAmount && transformedAmount && parseFloat(transformedAmount) > NumberTransform(parseFloat(winAmount));

	function confirmClicked() {
		sending = true;
		IncomingBetStore.acceptBet(bet, {
			adjusted_amount: parseFloat(stake)
		})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'To Win Bet Failed',
					message: (e.error && e.error[0]) || 'Problem accepting bet',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
				open = false;
			});
	}

	function calcOdds() {
		if (bet.bet_type.id === BetType.Multi) {
			return multiOdds(bet);
		}
		let odds = bet.legs.data.pluck('fixed_price');
		odds = odds.reduce((total, price) => total + price);
		odds = eachWay ? odds / 2 : odds;
		return odds;
	}

	function calcStake() {
		let newStake = Math.ceil((transformedAmount / (fixedPrice / 100 - 1)).toFixed(2)) * 100;
		if (parseFloat(newStake) > parseFloat(bet.bet_amount)) {
			return bet.bet_amount;
		}
		return newStake;
	}

	function handleKeydown(e) {
		if (e.key === 'Enter' && document.activeElement.id === `win-amount-${bet.id}`) {
			e.preventDefault();
			confirmClicked();
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />
{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">To Win</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<p>
				{#if eachWay}E/W{/if}
				Bet is {CurrencyFormat(bet.bet_amount)} @
				{getBetOddsForDisplay(bet)}
			</p>
			<p>
				Win amount:
				<span class="text-sm text-orange-500">{CurrencyFormat(winAmount)}</span>
			</p>
			<p class="mt-4 mb-2 font-semibold">
				Enter max win amount
				<span class="text-sm font-normal">(new stake: {CurrencyFormat(stake)})</span>
			</p>
			<input
				type="text"
				id={`win-amount-${bet.id}`}
				bind:value={transformedAmount}
				class="form-input focus:outline-none {error ? 'border-red-500' : ''}"
				bind:this={element}
				on:focus={() => element.select()}
			/>
			{#if error}
				<div class="text-center text-red-500">New win amount can't be higher than bet original win amount!</div>
			{/if}
			<LoadingButton
				on:click={confirmClicked}
				loading={sending}
				disabled={error}
				className="mt-4 mb-4 btn {error ? 'btn-primary-action-disabled' : 'btn-primary'}"
				>Accept [enter]
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel [esc]</button>
		</div>
	</Modal>
{/if}
